export enum PurchaseStage {
    EDIT = 'Редактирование',
    READY_FOR_PLACEMENT = 'Подготовка к размещению',
    PURCHASE_TO_EIS = 'Отправка в ЕИС',
    PURCHASE_IN_EIS = 'Размещенный договор',
    START = 'Подача заявок',
    WORK = 'Работа комиссии',
    END = 'Закупка завершена',
    ALL = 'Реестр закупок',
}

export enum ContractPerformanceStage {
    EDIT = 'Редактирование',
    READY_FOR_PLACEMENT = 'Подготовка к размещению',
    SENT_TO_EIS = 'Отправка в ЕИС',
    PERF_IN_EIS = 'Размещенное исполнение',
}

export enum NationalReestrType {
    NSI_NP_RRPP = 'Реестр российской промышленной продукции',
    NSI_NP_RRPO = 'Реестр российского программного обеспечения',
    NSI_NP_ERPP = 'Евразийский реестр промышленных товаров государств - членов ЕВРАЗЭС',
    NSI_NP_ERPO = 'Реестр евразийского программного обеспечения',
}

export enum BudgetResources {
    NO_BUDGET_RESOURCES_FZ44 = 'Нет финансирования за счет средств субсидии, предоставляемой в целях реализации национальных и федеральных проектов и (или) комплексного плана модернизации и расширения магистральной инфраструктуры',
    NATIONAL_FEDERAL_PROJECTS_SUBSIDIES = 'За счет средств субсидии, предоставляемой в целях реализации национальных и федеральных проектов и (или) комплексного плана модернизации и расширения магистральной инфраструктуры',
    // NATIONAL_PROJECTS_SUBSIDIES = 'За счет средств субсидий, выделяемых в рамках национальных проектов/За счет средств субсидии, предоставляемой в целях реализации национальных и федеральных проектов и (или) комплексного плана модернизации и расширения магистральной инфраструктуры',
    // RESOURCES_FZ44_NATIONAL_PROJECTS = 'За счет средств, предусмотренных контрактом 44-ФЗ, выделяемых в рамках национальных проектов',
    // RESOURCES_FZ44 = 'За счет средств, предусмотренных контрактом 44-ФЗ',
}

export type UserInfo = {
    guid: string
    first_name: string
    last_name: string
    patronymic: string
    email: string
    phone: string
    position: string
}

export type Suppliers = {
    guid: string | null
    supplier_name: string | null
    supplier_short_name: string | null
    supplier_inn: string | null
    supplier_address_country_name: string | null
    supplier_address_post_code: string | null
    supplier_address_region_name: string | null
    supplier_address_city: string | null
    supplier_address_street: string | null
    supplier_address_house: string | null
    supplier_address_building: string | null
    supplier_address_office: string | null
}

export type Contract = {
    guid: string
    registration_number: string
    notice_44: boolean
    notice_not_placed_by_fz223_p5_s4: boolean
    notice_44_num: string | null
    lot_44_num: string | null
    hide_purchase_contract: boolean
    termination: boolean
    extension: boolean
    prolongation: boolean
    customer_appealed_or_needs_approval: boolean
    customer_approval_or_antimonopoly_descision_date: string | null
    start_execution_term: string | null
    end_execution_term: string | null
    lot_num: number
    plan_registration_number: string | null
    plan_guid: string | null
    plan_position_number: number | null
    plan_position_type: string | null
    plan_position_guid: string | null
    plan_position_contract_subject: string | null
    url_eis: string | null
    url_vsrz: string | null
    url_kis_rmis: string | null
    create_date_time: string
    contract_customer: CustomerInfo
    blocked_customer: CustomerInfo | null
    contract_placer: CustomerInfo
    detached_org: CustomerInfo | null
    publication_date: string
    status: string
    version: number
    modification_description: string
    digital_purchase: boolean
    digital_purchase_code: string
    emergency: boolean
    provider: boolean
    provider_code: string | null
    change_contract: boolean
    contract_reg_number: string
    contract_name: string | null
    contract_date: string | null
    approve_date: string | null
    purchase_notice_guid: string | null
    purchase_notice_number: string | null
    purchase_publication_date_time: string | null
    purchase_notice_name: string | null
    lot_guid: string | null
    subject_contract: string | null
    purchase_type_info_code: string | null
    purchase_type_info_name: string | null
    resume_date: string | null
    supplier_guid: string
    supplier_short_name: string
    multi_supplier: MultiSupplier
    has_subcontractor: boolean
    has_subcontractor_code: string | null
    subcontractors_total: number | null
    has_good_info: boolean | null
    change_contract_stage: boolean | null
    additional_info: string | null
    price: number
    exchange_rate: number | null
    exchange_rate_date: string | null
    rub_price: number | null
    currency_code: string
    currency_digital_code: number | null
    currency_name: string
    start_execution_date: string | null
    end_execution_date: string | null
    stage_execution: boolean | null
    stage_contract_performance: StageContractPerformance | null
    long_term_contract_volumes: LongTermContractVolumes | null
    total_budget: number | null
    contract_change_docs: ContractChangeDoc | null
    contract_confirming_docs: ContractConfirmingDoc | null
    has_okpd_and_okdp_rows: boolean
    has_okpd2_rows: boolean
    is_electronic_place: boolean | null
    electronic_place_info: ElectronicPlaceInfo | null
    electorinc_place_publish_date: string | null
    electorinc_place_guid: string | null
    execution_supply: ExecutionSupply | null
    organization_guid: string
    user_guid: string
    supervisor_user_guid: string
    annotation: string | null
    contract_stage: string
    contract_status: string
    struct_guid: string | null
    struct_name: string | null
    type_object_contract: string | null
    is_nmcd_with_tax: boolean | null
    expense_items_guid: string | null
    expense_items_name: string | null
    upload_at: string | null
    update_at: string | null
    sys_created_at: string
    sys_updated_at: string
    first_name: string | null
    last_name: string | null
    patronymic: string | null
    user: UserInfo
    supervisor_user: UserInfo
    suppliers: Suppliers[]
    is_draft: boolean
}

export type MultiSupplier = {
    suppliers: ItemMultiSupplier[]
}

export type ItemMultiSupplier = {
    supplier_guid: string
    supplier_short_name: string
}

export type Currency = {
    code: string | null
    name: string | null
    digital_code: number | string | null
}

export type Attachment = {
    guid: string
    create_datetime: string
    filename: string
    description: string
    attachment_status: string
    organization_guid: string
    plan_guid: string
    url: string
    sys_updated_at: string
}

export type CurrencyList = {
    guid: string
    value_id: string
    num_code: string
    char_code: string
    name: string
    char_sign: string | null
}

export type CurrencyRate = {
    guid: string
    value_id: string
    nominal: number
    currency_date: string
    num_code: string
    char_code: string
    name: string
    value: number
    vunit_rate: number
    char_sign: string | null
}

export type TimeZone = {
    name: string
    offset: number
}

export type CustomerInfo = {
    iko: string
    inn: number
    kpp: number
    ogrn: number
    okfs: number
    okpo: number
    okato: string
    okopf: number
    okopf_name: string
    region: string
    full_name: string
    okfs_name: string
    time_zone: TimeZone
    short_name: string
    legal_address: string
    postal_address: string
    email: string | null
}

export type StageContractPerformance = {
    code: string
    stage_contract_performance_id: number
    stage_contract_performance_num: number
    start_stage_execution_date: string
    end_stage_execution_date: string
    price_stage: number
    price_stage_rub: number
    prepaid: string
    payment_schedule: boolean
}

export type ItemDetail = {
    month?: string
    year: number
    summ: number
    summ_rub?: number | null
    summ_prepaid_percent?: number
    summ_prepaid?: number
    summ_prepaid_rub?: number | null
}

export type Details = {
    items: ItemDetail[]
}

export type LongTermContractVolumes = {
    details: Details
    volume: number
    volume_rub?: number | null
    volume_price_prepaid_stage?: number | null
    volume_price_prepaid_stage_rub?: number | null
}

export type ContractDoc = {
    confirming_doc_code?: string | null
    confirming_doc_code_title?: string | null
    protocol_info_guid?: string
    protocol_name?: string
    additional_info?: string
    doc_date: string
    doc_num?: string
}

export type ContractChangeDoc = {
    contract_doc: ContractDoc[]
}

export type ContractConfirmingDoc = {
    contract_doc: ContractDoc[]
}

export type ElectronicPlaceInfo = {
    url: string
    name: string
    specialized: boolean
    electronic_place_id: string
}

export type ExecutionSupply = {
    type: string
    guarantee_reg_num: string
    sum: number
    currency: Currency
}

export type PurchaseCountAndSum = {
    contracts_count_perf: number
    contracts_sum_perf: number
    contracts_count_perfgb: number
    contracts_sum_perfgb: number
    // contracts_count_perfgood: number
    // contracts_sum_perfgood: number
    contracts_count_perfbad: number
    contracts_sum_perfbad: number
    contracts_count_close: number
    contracts_sum_close: number
    year?: number
}

export type ContractInfo = {
    contract_reg_number: string
    href: string
    contract_id: string
    status: string
    contract_number: number
    price_amount: number
    price_currency: string
    conclusion_date: string
    term_start: string
    term_end: string
    published_date: string
}

export type ContractSerchInfo = {
    inn: string
    date_from: string
    date_to: string
    records_per_page: number
    proxy_used: boolean
    cookie_used: boolean
    verify_ssl: boolean
}

export type ContractSearch = {
    query?: ContractSerchInfo
    contract_count: number
    pages_fetched?: number
    data: ContractInfo[]
    message?: string
}

export type ImportMessageDetails = {
    message: string
    details: string
}

export type ImportMessage = {
    import_message: Contract | ImportMessageDetails
}

export type CountryOfOrigin = {
    name: string
    digital_code: string
}

export type Country = {
    country: CountryOfOrigin[]
}

export type CountryManufacturer = {
    name: string
    digital_code: string
}

export type ContractPosition = {
    guid: string | null
    contract_position_name: string
    ordinal_number: number
    okpd2_code: string
    okpd2_name: string
    type_object_purchase: string | null
    country_of_origin: Country | null
    lot_item_national_regime: boolean | null
    registry_type: string | null
    reg_number: string | null
    score: number | null
    country_manufacturer: CountryManufacturer | null
    type_provision: string
    contract_num: string | null
    contract_end_stage: string | null
    target_code: string | null
    type_code: number | null
    amount_of_budget_funds: number | null
    producer_country: boolean | null
    impossible_to_determine_attr: boolean
    okei_code: string | null
    okei_name: string | null
    qty: number | null
    unit_price: number | null
    currency_code: string | null
    currency_digital_code: number | null
    currency_name: string | null
    exchange_rate: number | null
    rub_unit_price: number | null
    source_info: string | null
    organization_guid: string
    contract_guid: string
    annotation: string | null
    eis_guid: string | null
    sys_created_at: string
    sys_updated_at: string
}

export type ContractPerformance = {
    guid: string
    registration_number: string
    termination: boolean
    url_eis: string
    url_vsrz: string
    url_kis_rmis: string
    create_date_time: string
    performance_customer: string
    performance_placer: string
    publication_date: string
    status: string
    version: number
    completed: boolean
    cancel_reason: string
    modification_description: string
    has_penalty: boolean
    penalty_info: string | null
    contract_reg_number: string
    contract_guid: string
    contract_name: string
    contract_agency_name: string
    contract_supplier_name: string
    contract_lot_info: string
    contract_contract_date: string
    completion_stage_end_date: string | null
    total: number
    total_budget: number
    supplier_obligation_termination: string
    guarantee_requested_sum_info: string
    guarantee_retention_info: string
    is_draft: boolean
    from_perf_guid: string
    organization_guid: string
    user_guid: string
    supervisor_user_guid: string
    annotation: string
    performance_stage: string
    performance_status: string
    struct_guid: string
    struct_name: string
    type_object_contract: string
    is_nmcd_with_tax: boolean
    expense_items_guid: string
    expense_items_name: string
    upload_at: string
    update_at: string
    sys_created_at: string
    sys_updated_at: string
}

export type CountryList = {
    guid: string
    digital_code: string
    short_name: string
    name: string
    alpha2: string
    alpha3: string
}

export type ContractSupplier = {
    guid: string | null
    supplier_name: string | null
    supplier_short_name: string | null
    supplier_brand_name: string | null
    supplier_additional_full_name: string | null
    supplier_inn: string | null
    supplier_kpp: string | null
    supplier_okpo: string | null
    supplier_code: string | null
    supplier_additional_code: string | null
    supplier_additional_info: string | null
    supplier_type: string | null
    supplier_provider: boolean | null
    supplier_provider_code: string | null
    supplier_subcontractor: boolean | null
    supplier_subcontractor_code: string | null
    supplier_individual: boolean | null
    supplier_non_resident: boolean | null
    supplier_registration_date: string | null
    supplier_tax: boolean | null
    supplier_okopf: string | null
    supplier_okopf_name: string | null
    supplier_address_egrul_egrip_changed: boolean | null
    supplier_address_country_name: string | null
    supplier_address_digital_code: string | null
    supplier_address_post_code: string | null
    supplier_address_oktmo: string | null
    supplier_address_oktmo_name: string | null
    supplier_address_region_code: number | null
    supplier_address_region_name: string | null
    supplier_address_area: string | null
    supplier_address_city: string | null
    supplier_address_settlement: string | null
    supplier_address_street: string | null
    supplier_address_email: string | null
    supplier_address_phone: string | null
    supplier_address_office: string | null
    supplier_address_building: string | null
    supplier_address_house: string | null
    supplier_address_planning_structure: string | null
    supplier_address_admin_division: string | null
    supplier_provider_include_msp_date: string | null
    supplier_is_in_order_173n: boolean | null
    supplier_self_employed: boolean | null
    annotation: string | null
    organization_guid: string | null
    contract_guid: string | null
    supplier_guid: string | null
    sys_created_at: string | null
    sys_updated_at: string | null
    temp_id?: string
}

export type Okopf = {
    guid: string
    change_date_time: string
    business_status: number
    code: string
    name: string
    parent_code: string
    is_active: boolean
    user_guid: string
    user_modification_datetime: string
    user_modification_reason: string
}

export type Oktmo = {
    guid: string
    change_date_time: string
    start_date_active: string
    business_status: number
    code: string
    name: string
    parent_code: string
    is_active: boolean
    user_guid: string
    user_modification_datetime: string
    user_modification_reason: string
}

export type FindSupplier = {
    ref_type?: string
    name?: string
    raw_name?: string
    many_ceo?: number
    link?: string
    sex?: string
    ogrnip?: string
    raw_ogrnip?: string
    ogrn?: string
    raw_ogrn?: string
    inn?: string
    region_name?: string
    region?: string
    address?: string
    inactive?: number
    status_extended?: number
    ip_status_extended?: number
    type?: number
    ip_type?: number
    ceo_name?: string
    ceo_type?: string
    snippet_string?: string
    snippet_type?: string
    status_code?: number
    svprekrul_date?: string
    main_okved_id?: string
    okved_descr?: string
    authorized_capital?: string
    finance_revenue?: number
    finance_revenue_diff_type?: string
    finance_revenue_diff_value?: number
    finance_revenue_diff_percent?: number
    reg_date?: number
    okpo?: number
    url?: number
    aci_id?: number
}

export type ListOrgSupplierItem = {
    value: string
    data: {
        id: number
        wrk?: number
        fio?: string
        inn?: string
        ogrn?: string
        adr?: string
        cnt?: number
        c: 'cli' | 'man'
        ip?: number
        phone?: string
    }
}

export type SearchContractSupplierLResponse = {
    message?: string
    find_suppliers_l: ListOrgSupplierItem[]
}

export type ContactInfo = {
    email: string
    phone: string
    last_name: string
    first_name: string
    middle_name: string
}

export type PaymentInfo = {
    currency: Currency
    sum: number
    procedure: string
}

export type PlacingProcedureInfo = {
    summingup_place?: string
    summingup_date_time?: string
}

export type Purchase = {
    guid: string
    organization_guid: string
    notice_type: string | null
    create_date_time: string | null
    name: string | null
    customer: CustomerInfo | null
    purchase_method_code: number | null
    purchase_method_name: string | null
    placer: CustomerInfo | null
    contact: ContactInfo | null
    delivery_start_date_time: string | null
    delivery_end_date_time: string | null
    place: string | null
    procedure: string | null
    payment: PaymentInfo | null
    status: string | null
    version: number
    modification_description: string | null
    not_dishonest: boolean
    modification_date: string
    save_user_id: number | null
    delivery_place_indication: string | null
    emergency: boolean
    joint_purchase: boolean
    for_small_or_middle: boolean | null
    hide_purchase: boolean | null
    change_decision_date: string | null
    antimonopoly_decision_taken: boolean
    additional_info: string | null
    appl_submision_place: string | null
    appl_submision_start_date: string | null
    appl_submision_order: string | null
    envelope_opening_order: string | null
    appl_examination_order: string | null
    summingup_order: string | null
    auction_order: string | null
    consideration_second_part_place: string | null
    consideration_second_part_order: string | null
    electronic_place_info: ElectronicPlaceInfo | null
    placing_procedure: PlacingProcedureInfo | null
    submission_close_date_time: string | null
    publication_planned_date: string | null
    is_lot_oriented: boolean | null
    template_version: string | null
    plan_guid: string | null
    url_eis: string | null
    url_vsrz: string | null
    registration_number: number | null
    publication_date_time: string | null
    user_guid: string
    supervisor_user_guid: string
    annotation: string | null
    purchase_stage: string
    purchase_status: string
    is_draft: boolean
    upload_at: string | null
    update_at: string | null
    sys_created_at: string
    sys_updated_at: string
    first_name: string | null
    last_name: string | null
    patronymic: string | null
    user: UserInfo
    supervisor_user: UserInfo
}

export type PurchaseDataReestr = {
    guid: string
    organization_guid: string
    notice_type: string | null
    create_date_time: string | null
    registration_number: number
    purchase_stage: string | null
    purchase_status: string | null
    name: string | null
    lots_sum: string | null
    lots_currency: Currency | null
    lots_currency_digital_code: string | null
    purchase_method_code: number | null
    purchase_method_name: string | null
    status: string | null
    lots_count: number | null
    appl_submision_start_date: string | null
    submission_close_date_time: string | null
    placing_procedure: PlacingProcedureInfo | null
    version: number
    place: string | null
    delivery_start_date_time: string | null
    delivery_end_date_time: string | null
    publication_date_time: string | null
    sys_created_at: string
    sys_updated_at: string
    first_name: string | null
    last_name: string | null
    patronymic: string | null
    user_guid: string | null
    supervisor_user_guid: string | null
}

export type PurchaseInfo = {
    purchase_reg_number: string
    purchase_name: string
    href: string
    stage: string
    price_amount: number
    price_currency: string
    end_date: string
    published_date: string
    last_update_date: string
}

export type PurchaseSerchInfo = {
    inn: string
    date_from: string
    date_to: string
    records_per_page: number
    proxy_used: boolean
    cookie_used: boolean
    verify_ssl: boolean
}

export type PurchaseSearch = {
    query?: PurchaseSerchInfo
    purchase_count: number
    pages_fetched?: number
    data: PurchaseInfo[]
    message?: string
}

export type ExchangeInfo = {
    exchange_rate?: string
    exchange_rate_date?: string
}

export type DeliveryPlace = {
    state?: string | null
    region?: string | null
    address?: string | null
    region_okato?: string | null
}

export type PurchaseCategory = {
    code?: string
    name?: string
}

export type CompletingSupplyInfo = {
    summ?: string
    extra?: string
    currency?: Currency
}

export type LotCustomers = {
    lot_customer?: string
}

export type Cancellation = {
    cancel_date?: string | null
    cancel_info?: string | null
    emergency?: boolean | null
}

export type LotCriterion = {
    code?: string | null
    name?: string | null
    value?: string | null
}

export type Criteria = {
    items?: LotCriterion[] | null
}

export type PurchaseLot = {
    guid: string
    ordinal_number: number
    lot_edit_enabled: boolean
    subject: string
    currency: Currency
    exchange_info: ExchangeInfo | null
    initial_sum: number | number
    starting_contract_price_rub: number | null
    price_formula: string | null
    commodity_price: number | number
    commodity_price_rub: number | number
    max_contract_price: number | number
    max_contract_price_rub: number | number
    initial_sum_info: string | null
    order_pricing: string | null
    delivery_place: DeliveryPlace | null
    for_small_or_middle: boolean
    exclude_purchase_from_plan: boolean
    subcontractors_requirement: boolean
    ignored_purchase: boolean
    purchase_category: PurchaseCategory | null
    centralized: boolean
    purchase_description: string | null
    application_supply_needed: boolean | null
    application_supply_summ: number | null
    application_supply_currency: Currency | null
    application_supply_extra: string | null
    major_contract_conditions: string | null
    antimonopoly_decision_taken: boolean | null
    completing_supply_needed: boolean | null
    completing_supply_info: CompletingSupplyInfo | null
    delivery_place_indication: string | null
    joint_lot: boolean
    lot_customers: LotCustomers | null
    plan_registration_number: number | null
    plan_guid: string | null
    plan_pos_number: number | null
    lot_plan_position: string | null
    plan_pos_guid: string | null
    cancelled: boolean
    cancellation: Cancellation | null
    criteria: Criteria | null
    new_codes: boolean
    superiority_national_regime: boolean | null
    annotation: string | null
    organization_guid: string
    purchase_guid: string
    sys_created_at: string
    sys_updated_at: string
}

export type SubstantiationNationalRegimeInfo = {
    code?: string | null
    info?: string | null
    value?: string | null
}

export type PurchaseLotItem = {
    length: number
    guid: string
    ordinal_number: number
    okpd2_code: string | null
    okpd2_name: string | null
    okved2_code: string | null
    okved2_name: string | null
    okei_code: string | null
    okei_name: string | null
    qty: number | null
    delivery_place: DeliveryPlace | null
    commodity_item_price: number | null
    commodity_item_price_rub: number | null
    prohibition_national_regime: boolean | null
    constraint_national_regime: boolean | null
    exception_national_regime: boolean | null
    substantiation_national_regime_info: SubstantiationNationalRegimeInfo | null
    additional_info: string | null
    annotation: string | null
    organization_guid: string
    purchase_guid: string
    purchase_lot_guid: string
    sys_created_at: string
    sys_updated_at: string
}
